import Form from '../helpers/forms/form';

function createBlock() {
    const block = document.createElement('p');
    block.classList.add('form__message');
    return block;
}

function onSuccess(response, instance) {
    const { form } = instance;
    const messages = form.querySelector('.form__messages');
    const block = createBlock(form);

    console.log(response.data);

    block.innerText = response.data.message;
    if (response.data.success !== true) {
        messages.classList.add('warning');
        messages.classList.remove('error');
        block.classList.add('warning');
        block.classList.remove('error');
        form.classList.remove('is-successful');
    } else {
        messages.classList.remove('error', 'warning');
        block.classList.add('success');
        block.classList.remove('error', 'warning');
        form.classList.add(instance.options.classes.form.onSuccess);
    }

    messages.innerHTML = "";
    messages.appendChild(block);
}

function onError(error, instance) {
    const { form } = instance;
    const messages = form.querySelector('.form__messages');
    const block = createBlock(form);

    form.classList.remove('is-successful');
    messages.classList.remove('warning');
    messages.classList.add('error');
    block.classList.remove('warning');
    block.classList.add('error');
    block.innerText = 'Something went wrong, please try again';

    messages.innerHTML = "";
    messages.appendChild(block);
}

const options = {
    constraints: {
        n_first_name: {
            presence: {
                allowEmpty: false,
            },
        },
        n_last_name: {
            presence: {
                allowEmpty: false,
            },
        },
        n_email: {
            presence: {
                allowEmpty: false,
            },
            email: true,
        },
    },
    selectors: {
        inputGroup: '.form__group',
        label: '[data-label]',
    },
    form: {
        // onValid: (form, instance) => {},
    },
    input: {
        // onValid: (input, instance) => {},
        // onError: (input, error, instance) => {},
    },
    request: {
        type: 'post',
        url: '/xhr/newsletter/subscribe.php',
        success: (response, instance) => {

            onSuccess(response, instance);
        },
        error: (error, instance) => {
            onError(error, instance);
        },
        submitDelay: 300,
    },
};

function init() {
    const form = document.querySelector('form.form--newsletter.js-validate');

    if (form !== null) {
        // eslint-disable-next-line no-new
        new Form(form, options);
    }
}

init();
